<template>
		<div>
				<ckeditor class="text-editor" :editor="editor" v-model="inputValue" :config="editorConfig"/>
		</div>
</template>

<script>
	import CKEditor from '@ckeditor/ckeditor5-vue2';
	import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

	export default {
		name: 'TextEditor',

		components: {
			ckeditor: CKEditor.component,
		},

		props: {
			value: String,
			required: Boolean,
			placeholder: String,
		},

		beforeMount() {
			this.inputValue = this.value
			this.editorConfig.placeholder = this.placeholder
			this.editorConfig.required = this.required
		},

		data: () => {
			return {
				editor: ClassicEditor,
				editorConfig: {
					removePlugins: [ 'ImageUpload', 'MediaEmbed', 'Table' ],
				},
				inputValue: null,
			}
		},

		methods: {},

		computed: {},

		watch: {
			inputValue(to, from) {
				this.$emit('input', to)
			}
		}


	}
</script>

<style lang="scss">
		.ck-editor__editable {
				min-height: 300px;
		}

		.ck.ck-editor__editable > .ck-placeholder::before {
				color: #b1b7ba;
				white-space: break-spaces;
		}
</style>